import usePrivateLink from "../../../config/usePrivateLink";
import React, { useEffect, useRef, useState } from "react";

import Header from "../../../master/SideBar";
import Nav from "../../../master/NavBar";
import { Link } from "react-router-dom";
import { viewlist } from "../../../../api/BatchService";
import {
  formatDate,
  ToastMain,
  SweetAlertShow,
  LoadingDiv,
} from "../../../master/Master";
import ".././print.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getSessions } from "../../../../api/SessionsService";
import TestLayout from ".././TestLayout";
import { fetchAnnualExcel } from "../../../../api/TestServiceV2";
import Footer from "../../footer";
import { StudentListt } from "../../../../api/StudentServices";

const AnnualTable = () => {
  const hasAccess = usePrivateLink();
  const [batch, setBatch] = useState();
  const [selectedBatch, setSelectedBatch] = useState("");
  const [List, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [batchStudents, setBatchStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState("");
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSessions] = useState("");
  const [error, setError] = useState("");

  const exportToExcel = () => {
    if (!Array.isArray(List?.course_and_fees?.[0]?.tests)) return;

    const exportData = [];

    List.course_and_fees[0].tests.forEach((testData, i) => {
      const markEntry = testData?.marks?.[0];
      const summary = getTestSummary(testData);

      const row = {
        "Sr No": i + 1,
        "Test Name": testData.title || "-",
        Date: formatDate(testData.date),
        Rank: markEntry?.rank || "-",
        "Obtained Marks": summary.obtainedMarks,
        "Total Marks": summary.totalMarks,
        Percentage: summary.percent + "%",
      };

      // Combined Test
      if (testData.exam_mode === "combined") {
        row["Combined Test"] =
          `${summary.obtainedMarks}/${summary.totalMarks} (${summary.percent}%)`;
      } else {
        // Normal Test
        const mark = testData?.marks?.[0];

        const subjectIds = JSON.parse(mark?.subject_ids || "[]");
        const totalMarksArr = JSON.parse(mark?.subjects_marks || "[]");
        const obtainedMarksArr = JSON.parse(mark?.obtained_marks || "[]");

        (testData.subjects_list || []).forEach((subj) => {
          let index = -1;

          // subject_ids hai to usse match karo
          if (subjectIds.length > 0) {
            index = subjectIds.findIndex(
              (id) => Number(id) === Number(subj.id),
            );
          } else {
            // subject_ids null ya [] hai to subjects_list ke order se
            index = (testData.subjects_list || []).findIndex(
              (s) => Number(s.id) === Number(subj.id),
            );
          }

          if (
            index === -1 ||
            totalMarksArr[index] === undefined ||
            obtainedMarksArr[index] === undefined
          ) {
            row[subj.name] = "-";
          } else {
            const total = Number(totalMarksArr[index]);
            const obtained = Number(obtainedMarksArr[index]);

            row[subj.name] = `${obtained}/${total}`;
          }
        });
      }

      exportData.push(row);
    });

    const ws = XLSX.utils.json_to_sheet(exportData);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Test Results");

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(
      new Blob([excelBuffer], {
        type: "application/octet-stream",
      }),
      `TestResults_${List?.name || "Student"}.xlsx`,
    );
  };

  const cardRefs = useRef([]);

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions();
      if (response?.data?.status) {
        const activeSession = response?.data?.data.find(
          (session) => session.status === "1",
        );
        setSelectedSessions(activeSession.id);
        setSessions(response?.data?.data);
        // setSessions(activeSessions);
      } else {
        setError("Failed to fetch session?.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  const fetchBatches = async () => {
    const addUrl = `&session_id=${selectedSession}`;
    try {
      const response = await viewlist(addUrl);
      if (response?.data?.status) {
        setBatch(response.data);
      } else {
        alert("Failed to fetch batches");
      }
    } catch (err) {
      console.error(err);
      alert("Error fetching batches");
    }
  };

  const fetchListDAta = async () => {
    setLoading(true);
    let addUrl = `&batch_id=${selectedBatch}&student_id=${selectedStudent}`;
    try {
      const response = await fetchAnnualExcel(addUrl);
      if (response.data.status) {
        setList(response?.data?.data);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Went Wrong!",
      // });
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchStudents = async () => {
    try {
      setLoading(true);
      const res = await StudentListt(`&batch_id=${selectedBatch}`);
      if (res?.data?.status) {
        setBatchStudents(res.data.data || []);
      } else {
        setBatchStudents([]);
      }
    } catch (err) {
      console.error(err);
      setBatchStudents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedBatch) {
      fetchStudents();
    }
  }, [selectedBatch]);

  useEffect(() => {
    if (selectedBatch && selectedStudent) {
      fetchListDAta();
    }
  }, [selectedBatch, selectedStudent]);

  useEffect(() => {
    if (selectedSession) {
      fetchBatches();
    }
  }, [selectedSession]);

  const allSubjects = [];

  (List?.course_and_fees?.[0]?.tests || []).forEach((test) => {
    if (test.exam_mode === "combined") {
      allSubjects.push({ name: "Combined Test" });
    } else {
      allSubjects.push(...(test.subjects_list || []));
    }
  });

  const uniqueSubjects = [
    ...new Map(allSubjects.map((item) => [item.name, item])).values(),
  ];
  // ✅ Print only report card
  const handlePrint = () => {
    const printContents = cardRefs.current[0]?.innerHTML;

    if (!printContents) return;

    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Annual Performance Report</title>

        <style>

          @page{
            size:A4 landscape;
            margin:10mm;
          }

          *{
            box-sizing:border-box;
          }

          body{
            margin:0;
            padding:10px;
            font-family:Arial,sans-serif;
            color:#000;
          }

          h1,h2,h3,h4,h5,h6{
            margin:0 0 10px;
          }

          .card{
            border:none !important;
            box-shadow:none !important;
          }

          .card-header{
            background:#fff !important;
            border-bottom:1px solid #ddd;
            padding-bottom:12px;
            margin-bottom:12px;
          }

          .table-responsive{
            overflow:visible !important;
            width:100%;
          }

          table{
            width:100%;
            border-collapse:collapse;
            table-layout:auto;
            font-size:10px;
          }

          thead{
            display:table-header-group;
          }

          tfoot{
            display:table-footer-group;
          }

          tr{
            page-break-inside:avoid;
          }

          th,
          td{
            border:1px solid #bbb;
            padding:5px;
            white-space:nowrap;
            text-align:center;
            vertical-align:middle;
          }

          th{
            background:#ececec !important;
            font-weight:bold;
          }

          .badge{
            border:1px solid #444;
            padding:3px 8px;
            border-radius:20px;
          }

        </style>

      </head>

      <body>

        ${printContents}

      </body>

    </html>
  `);

    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  const [permissions, setPermissions] = useState([]);

  const getTestSummary = (testData) => {
    const mark = testData?.marks?.[0];

    if (!mark) {
      return {
        totalMarks: 0,
        obtainedMarks: 0,
        percent: "0.00",
      };
    }

    // Combined Test
    if (testData.exam_mode === "combined") {
      const total = Number(
        testData.combined_marks || testData.total_marks || 0,
      );
      const obtained = Number(mark.obtained_total || 0);

      return {
        totalMarks: total,
        obtainedMarks: obtained,
        percent: total > 0 ? ((obtained / total) * 100).toFixed(2) : "0.00",
      };
    }

    // Normal Test
    const totalMarksArr = JSON.parse(mark.subjects_marks || "[]");
    const obtainedMarksArr = JSON.parse(mark.obtained_marks || "[]");

    const total = totalMarksArr.reduce((a, b) => a + Number(b || 0), 0);
    const obtained = obtainedMarksArr.reduce((a, b) => a + Number(b || 0), 0);

    return {
      totalMarks: total,
      obtainedMarks: obtained,
      percent: total > 0 ? ((obtained / total) * 100).toFixed(2) : "0.00",
    };
  };

  useEffect(() => {
    const userPermissions = localStorage.getItem("user_permissions");
    const parsedPermissions = userPermissions
      ? JSON.parse(userPermissions)
      : [];

    setPermissions(JSON.parse(userPermissions)?.permissions);
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid py-3">
                <div className="row">
                  <TestLayout />

                  <div className="col-12">
                    {/* =====================================================
                      PAGE HEADER CARD
                  ====================================================== */}
                    <div className="card shadow-sm border-0 mb-4">
                      <div className="card-body p-4">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                          <div className="d-flex align-items-center">
                            <div className="me-3">
                              <div
                                className="bg-label-primary rounded-3 d-flex align-items-center justify-content-center me-3"
                                style={{
                                  width: 48,
                                  height: 48,
                                  minWidth: 48,
                                }}
                              >
                                <i className="ri-file-chart-line fs-3 text-primary"></i>
                              </div>
                            </div>

                            <div>
                              <h3 className="fw-bold mb-1">
                                Annual Performance Report
                              </h3>

                              <p className="text-muted mb-0">
                                View complete yearly performance of a student.
                              </p>
                            </div>
                          </div>

                          <div>
                            <span className="badge bg-primary fs-6 px-3 py-2 rounded-pill">
                              <i className="ri-user-line me-1"></i>
                              {selectedStudent
                                ? "1 Student Selected"
                                : "No Student"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* =====================================================
                      FILTER CARD
                  ====================================================== */}
                    <div className="card shadow-sm border-0 mb-4">
                      <div className="card-header bg-transparent border-bottom py-3 px-4">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <div className="me-2">
                              <i className="ri-filter-3-line ri-20px text-primary"></i>
                            </div>

                            <div>
                              <h5 className="fw-bold mb-0">Report Filters</h5>
                              <small className="text-muted">
                                Select session, batch and student
                              </small>
                            </div>
                          </div>

                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm px-3"
                            onClick={() => {
                              setSelectedBatch("");
                              setSelectedStudent("");
                            }}
                          >
                            <i className="ri-refresh-line me-1"></i>
                            Reset
                          </button>
                        </div>
                      </div>

                      <div className="card-body p-4">
                        <div className="row g-3">
                          {/* Session */}
                          <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                name="session"
                                value={selectedSession}
                                onChange={(e) =>
                                  setSelectedSessions(e.target.value)
                                }
                              >
                                {sessions?.map((session) => (
                                  <option key={session?.id} value={session?.id}>
                                    {session?.session}:
                                    {session?.status == "1"
                                      ? " Active"
                                      : " Inactive"}
                                  </option>
                                ))}
                              </select>

                              <label>
                                <i className="ri-calendar-line me-1"></i>
                                Filter Session
                              </label>
                            </div>
                          </div>

                          {/* Batch */}
                          <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                value={selectedBatch}
                                onChange={(e) =>
                                  setSelectedBatch(e.target.value)
                                }
                              >
                                <option value="">Select Batch</option>

                                {batch?.data?.map((batchItem, i) => {
                                  const courseTitle =
                                    batchItem?.course?.title || "";

                                  const shortCourseTitle =
                                    courseTitle.length > 20
                                      ? courseTitle.substring(0, 20) + "..."
                                      : courseTitle;

                                  return (
                                    <option key={i} value={batchItem?.id}>
                                      {`${batchItem?.title} (${shortCourseTitle}) (${batchItem?.id})`}
                                    </option>
                                  );
                                })}
                              </select>

                              <label>
                                <i className="ri-group-line me-1"></i>
                                Batch
                              </label>
                            </div>
                          </div>

                          {/* Student */}
                          <div className="col-xl-4 col-lg-4 col-md-12">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                value={selectedStudent}
                                onChange={(e) =>
                                  setSelectedStudent(e.target.value)
                                }
                              >
                                <option value="">Select Student</option>

                                {loading ? (
                                  <option>Loading...</option>
                                ) : batchStudents.length === 0 ? (
                                  <option>No students found</option>
                                ) : (
                                  batchStudents.map((student) => (
                                    <option key={student.id} value={student.id}>
                                      {student.name} - {student.registration_no}
                                    </option>
                                  ))
                                )}
                              </select>

                              <label>
                                <i className="ri-user-search-line me-1"></i>
                                Select Student{" "}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* =====================================================
                      ACTION CARD
                  ====================================================== */}
                    {selectedStudent && (
                      <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body px-4 py-3">
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                            <div className="d-flex align-items-center">
                              <div className="me-3">
                                <i className="ri-file-chart-line ri-22px text-primary"></i>
                              </div>

                              <div>
                                <h6 className="fw-bold mb-0">Report Actions</h6>

                                <small className="text-muted">
                                  Print or export the annual performance report
                                </small>
                              </div>
                            </div>

                            <div className="d-flex gap-2">
                              {hasAccess("/tests/report/print") && (
                                <button
                                  type="button"
                                  className="btn btn-outline-primary px-3"
                                  onClick={handlePrint}
                                  title="Print"
                                >
                                  <i className="bi bi-printer me-1"></i>
                                  Print
                                </button>
                              )}

                              {/* {hasAccess("/annual/report/table/export") && ( */}
                              {hasAccess("/tests/obtained/marks/export") && (
                                <button
                                  type="button"
                                  className="btn btn-success px-3"
                                  onClick={exportToExcel}
                                  title="Export Excel"
                                >
                                  <i className="bi bi-cloud-arrow-down ri-20px me-1"></i>
                                  Excel
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}


                    {/* =====================================================
                      ANNUAL PERFORMANCE REPORT
                      DO NOT CHANGE PRINT STRUCTURE / LOGIC
                  ====================================================== */}
                    {Array.isArray(List?.course_and_fees?.[0]?.tests) &&
                      List.course_and_fees[0]?.tests.length > 0 && (
                        <div className="row">
                          <div className="col-md-12 mb-4">
                            <div
                              ref={(el) => (cardRefs.current[0] = el)}
                              className="card border-0 shadow-sm"
                            >
                              <div className="card-header bg-transparent">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    <h5 className="fw-bold mb-0">
                                      Annual Performance Summary
                                    </h5>

                                    <small className="text-muted">
                                      Student : {List?.name}
                                    </small>
                                  </div>
                                </div>
                              </div>

                              <div className="card-body p-0">
                                <div className="table-responsive">
                                  <table
                                    className="table table-bordered align-middle mb-0"
                                    style={{
                                      width: "max-content",
                                      minWidth: "100%",
                                    }}
                                  >
                                    <thead
                                      className="table-light"
                                      style={{
                                        display: "table-header-group",
                                      }}
                                    >
                                      <tr>
                                        <th>SR.No</th>
                                        <th>Test</th>
                                        <th>Date</th>

                                        {uniqueSubjects.map((subj, idx) => (
                                          <th key={idx}>{subj.name}</th>
                                        ))}

                                        <th>Student Rank</th>
                                        <th>Obtain Marks</th>
                                        <th>Total Marks</th>
                                        <th>Percentage</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {(() => {
                                        let grandTotalMarks = 0;
                                        let grandObtainMarks = 0;

                                        return (
                                          <>
                                            {List?.course_and_fees[0]?.tests.map(
                                              (testData, i) => {
                                                const markEntry =
                                                  testData?.marks?.[0];

                                                const summary =
                                                  getTestSummary(testData);

                                                const totalMarks =
                                                  summary.totalMarks;

                                                const obtainMarks =
                                                  summary.obtainedMarks;

                                                const percent = summary.percent;

                                                grandTotalMarks +=
                                                  summary.totalMarks;

                                                grandObtainMarks +=
                                                  summary.obtainedMarks;

                                                return (
                                                  <tr
                                                    key={i}
                                                    style={{
                                                      pageBreakInside: "avoid",
                                                    }}
                                                  >
                                                    <td>{i + 1}</td>

                                                    <td>
                                                      {testData.title || "-"}
                                                    </td>

                                                    <td>
                                                      {formatDate(
                                                        testData.date,
                                                      )}
                                                    </td>

                                                    {uniqueSubjects.map(
                                                      (subj, idx) => {
                                                        if (
                                                          testData.exam_mode ===
                                                          "combined"
                                                        ) {
                                                          if (
                                                            subj.name ===
                                                            "Combined Test"
                                                          ) {
                                                            return (
                                                              <td key={idx}>
                                                                {
                                                                  summary.obtainedMarks
                                                                }{" "}
                                                                /{" "}
                                                                {
                                                                  summary.totalMarks
                                                                }{" "}
                                                                (
                                                                {
                                                                  summary.percent
                                                                }
                                                                %)
                                                              </td>
                                                            );
                                                          }

                                                          return (
                                                            <td key={idx}>-</td>
                                                          );
                                                        }

                                                        const mark =
                                                          testData?.marks?.[0];

                                                        const subjectIds =
                                                          JSON.parse(
                                                            mark?.subject_ids ||
                                                            "[]",
                                                          );

                                                        const totalMarksArr =
                                                          JSON.parse(
                                                            mark?.subjects_marks ||
                                                            "[]",
                                                          );

                                                        const obtainedMarksArr =
                                                          JSON.parse(
                                                            mark?.obtained_marks ||
                                                            "[]",
                                                          );

                                                        let index = -1;

                                                        if (
                                                          subjectIds.length > 0
                                                        ) {
                                                          index =
                                                            subjectIds.findIndex(
                                                              (id) =>
                                                                Number(id) ===
                                                                Number(subj.id),
                                                            );
                                                        } else {
                                                          index = (
                                                            testData.subjects_list ||
                                                            []
                                                          ).findIndex(
                                                            (s) =>
                                                              Number(s.id) ===
                                                              Number(subj.id),
                                                          );
                                                        }

                                                        if (
                                                          index === -1 ||
                                                          totalMarksArr[
                                                          index
                                                          ] === undefined ||
                                                          obtainedMarksArr[
                                                          index
                                                          ] === undefined
                                                        ) {
                                                          return (
                                                            <td key={idx}>-</td>
                                                          );
                                                        }

                                                        const total = Number(
                                                          totalMarksArr[index],
                                                        );

                                                        const obtained = Number(
                                                          obtainedMarksArr[
                                                          index
                                                          ],
                                                        );

                                                        return (
                                                          <td key={idx}>
                                                            {obtained}/{total} (
                                                            {total > 0
                                                              ? (
                                                                (obtained /
                                                                  total) *
                                                                100
                                                              ).toFixed(2)
                                                              : "0.00"}
                                                            %)
                                                          </td>
                                                        );
                                                      },
                                                    )}

                                                    <td>
                                                      {markEntry?.rank || "-"}
                                                    </td>

                                                    <td>
                                                      {obtainMarks || "-"}
                                                    </td>

                                                    <td>{totalMarks || "-"}</td>

                                                    <td>{percent}%</td>
                                                  </tr>
                                                );
                                              },
                                            )}

                                            <tr
                                              className="table-primary fw-bold"
                                              style={{
                                                pageBreakInside: "avoid",
                                                background: "#efefef",
                                              }}
                                            >
                                              <td colSpan={3}>Grand Total</td>

                                              {uniqueSubjects.map((_, idx) => (
                                                <td
                                                  key={idx}
                                                  style={{
                                                    minWidth: "80px",
                                                    fontSize: "10px",
                                                  }}
                                                >
                                                  -
                                                </td>
                                              ))}

                                              <td>-</td>

                                              <td>{grandObtainMarks}</td>

                                              <td>{grandTotalMarks}</td>

                                              <td>
                                                {grandTotalMarks > 0
                                                  ? (
                                                    (grandObtainMarks /
                                                      grandTotalMarks) *
                                                    100
                                                  ).toFixed(2)
                                                  : "0.00"}
                                                %
                                              </td>
                                            </tr>
                                          </>
                                        );
                                      })()}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                    {/* =====================================================
                      EMPTY STATE
                  ====================================================== */}
                    {selectedStudent &&
                      (!Array.isArray(List?.course_and_fees?.[0]?.tests) ||
                        List.course_and_fees[0]?.tests.length === 0) &&
                      !loading && (
                        <div className="card shadow-sm border-0">
                          <div className="card-body text-center py-5">
                            <div className="mb-3">
                              <i className="ri-file-search-line ri-48px text-muted"></i>
                            </div>

                            <h5 className="fw-bold">
                              No Performance Data Found
                            </h5>

                            <p className="text-muted mb-0">
                              No test results are available for the selected
                              student.
                            </p>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              </div>

              <Footer />

              <div className="content-backdrop fade"></div>
            </div>
          </div>

          <div className="layout-overlay layout-menu-toggle"></div>
          <div className="drag-target"></div>
        </div>
      </div>
    </>
  );
};

export default AnnualTable;
